import { MarginExpenseTypes } from '../enums/margin-expense-types.enum';

export const MarginExpenseTypeLimits = new Map<MarginExpenseTypes, number>([[MarginExpenseTypes.OTHER, 20]]);

export const MarginExpenseReimbursementTypes = [
    MarginExpenseTypes.MILEAGE_REIMBURSEMENT,
    MarginExpenseTypes.BAGGAGE_FEES,
    MarginExpenseTypes.EXPENSE_ALLOWANCE
];

export const MarginExpenseInternalCostTypes = [
    MarginExpenseTypes.PATIENT_COMPENSATION_FUND,
    MarginExpenseTypes.REFERRAL_BONUS
];
